import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <header className="desktop-view">
        <div className="header_wrapper">
          <div className="row align-items-center m-0">
            <div className="col-md-3">
              <div className="logoImg">
                <a href="tel:+916367607678">
                  <figure>
                    <img
                      src="/logo.png"
                      //   style={{ width: 270, height: 100 }}
                      alt="vinayak24x7"
                    />
                  </figure>
                </a>
              </div>
            </div>
            <div className="col-md-9 p-0">
              <div
                className="rightSide"
                style={{ marginBottom: "7px!important" }}
              >
                <div className="top_header">
                  <div className="location btnlocation" data-popup="popup-reg">
                    <span>
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 28 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6416 17.9067C16.0396 17.9067 17.9836 15.9628 17.9836 13.5646C17.9836 11.1667 16.0396 9.22269 13.6416 9.22269C11.2435 9.22269 9.29956 11.1667 9.29956 13.5646C9.29956 15.9628 11.2435 17.9067 13.6416 17.9067Z"
                          stroke="white"
                          strokeWidth={2}
                        />
                        <path
                          d="M1.97785 11.0319C4.71944 -1.01992 22.5745 -1.006 25.3022 11.0459C26.9026 18.1155 22.505 24.0997 18.65 27.8016C15.8528 30.5014 11.4273 30.5014 8.61612 27.8016C4.77511 24.0997 0.377431 18.1016 1.97785 11.0319Z"
                          stroke="white"
                          strokeWidth={3}
                        />
                      </svg>
                    </span>
                    <p>Jaipur</p>
                    {/* <img src="/icons/down-arrow.svg" alt="vinayak24x7" /> */}
                  </div>
                  <div className="right_top_header">
                    <div className="timeSection">
                      <span>
                        24x7 Emergency Car Breakdown &amp; Roadside Assistance
                      </span>
                    </div>
                    {/* <div className="login">
                      <span>
                        <svg
                          width={19}
                          height={19}
                          viewBox="0 0 19 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 20.4286V19.2143C1 14.5199 4.80558 10.7143 9.5 10.7143C14.1944 10.7143 18 14.5199 18 19.2143V20.4286"
                            stroke="white"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9.49996 10.7143C12.1824 10.7143 14.3571 8.53962 14.3571 5.85714C14.3571 3.17462 12.1824 1 9.49996 1C6.81744 1 4.64282 3.17462 4.64282 5.85714C4.64282 8.53962 6.81744 10.7143 9.49996 10.7143Z"
                            stroke="white"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <a href="/Login">Login</a>
                    </div> */}
                    <div className="socialIcon">
                      <ul>
                        <li>
                          <a href="https://www.facebook.com">
                            <img src="/icons/facebook.svg" alt="vinayak24x7" />
                          </a>
                        </li>
                        <li>
                          <a href="https://twitter.com">
                            <img
                              style={{ width: 15 }}
                              src="/icons/twitter.jpeg"
                              alt="vinayak24x7"
                            />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com">
                            <img src="/icons/instagram.svg" alt="vinayak24x7" />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.youtube.com">
                            <img src="/icons/youtube.svg" alt="vinayak24x7" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="mid_header">
                  <ul className="contact_box">
                    <li className="contactInfo">
                      <a href="tel:+916367607678">
                        <svg
                          width={26}
                          height={26}
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.2957 16.3932L15.305 17.3603C11.9339 15.6683 9.85157 13.7247 8.63969 10.695L9.57278 5.68983L7.80898 1H3.26333C1.89688 1 0.820848 2.1292 1.02493 3.48032C1.53441 6.85335 3.03663 12.9691 7.42782 17.3603C12.0392 21.9717 18.6809 23.9728 22.3363 24.7681C23.7479 25.0753 25 23.9741 25 22.5296V18.1858L20.2957 16.3932Z"
                            stroke="#F9A602"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                      <div className="contact_detail">
                        <a href="tel:+916367607678">+91 6367607678</a>
                        <span>Emergency Car Breakdown Service</span>
                      </div>
                    </li>
                    <li className="contactInfo">
                      <a href="tel:+91 6367607678">
                        <svg
                          width={26}
                          height={25}
                          viewBox="0 0 26 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.66663 9H18.3333"
                            stroke="#F9A602"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M6.33337 14.3333H7.66671"
                            stroke="#F9A602"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M18.3334 14.3333H19.6667"
                            stroke="#F9A602"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 19.6667V10.8807C1 10.5196 1.07336 10.1621 1.21561 9.83027L4.30733 2.61621C4.72755 1.63572 5.69165 1 6.75839 1H19.2416C20.3084 1 21.2724 1.63572 21.6927 2.61621L24.7844 9.83027C24.9267 10.1621 25 10.5196 25 10.8807V19.6667M1 19.6667V22.8667C1 23.3085 1.35817 23.6667 1.8 23.6667H5.53333C5.97516 23.6667 6.33333 23.3085 6.33333 22.8667V19.6667M1 19.6667H6.33333M25 19.6667V22.8667C25 23.3085 24.6419 23.6667 24.2 23.6667H20.4667C20.0248 23.6667 19.6667 23.3085 19.6667 22.8667V19.6667M25 19.6667H19.6667M6.33333 19.6667H19.6667"
                            stroke="#F9A602"
                            strokeWidth={2}
                          />
                        </svg>
                      </a>
                      <div className="contact_detail">
                        <a href="tel:+916367607678">24/7 Car Mechanic</a>
                        <span>Emergency Car Breakdown Service</span>
                      </div>
                    </li>
                  </ul>
                  <div className="book_btn">
                    <svg
                      width="220"
                      height="56"
                      viewBox="0 0 220 56"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="1"
                        y="1"
                        width="218"
                        height="54"
                        rx="28"
                        fill="#f9a602"
                      />
                      <path
                        d="M48 20
           c-2 0-4 2-4 4
           c0 12 10 22 22 22
           c2 0 4-2 4-4
           v-4
           c0-2-1-3-3-3
           l-5-1
           c-1 0-2 0-3 1
           l-2 2
           c-4-2-7-5-9-9
           l2-2
           c1-1 1-2 1-3
           l-1-5
           c0-2-1-3-3-3
           h-4z"
                        fill="#ffffff"
                      />
                      <text
                        x="90"
                        y="36"
                        font-family="Arial, sans-serif"
                        font-size="18"
                        font-weight="bold"
                        fill="#ffffff"
                      >
                        Call Now
                      </text>
                    </svg>
                  </div>
                </div>
                <div className="header_navbar">
                  <div className="navbar">
                    <ul className="navigation">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/">
                          Services{" "}
                          <img src="/icons/down-arrow.svg" alt="vinayak24x7" />
                        </Link>
                        <ul className="DropDownMenu">
                          <li>
                            <Link to="/">Body-Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Break Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Car Ac Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Engine Diagnostic</Link>
                          </li>
                          <li>
                            <Link to="/">Wheel Alignment</Link>
                          </li>
                          <li>
                            <Link to="/">Oil Change</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/">
                          Premium Cars Services{" "}
                          <img src="/icons/down-arrow.svg" alt="vinayak24x7" />
                        </Link>
                        <ul className="DropDownMenu">
                          <li>
                            <Link to="/">Audi Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Mercedes Repair</Link>
                          </li>
                          <li>
                            <Link to="/">BMW Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Jaguar Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Porche Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Bentley Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Land Rover Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Lexus Repair</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/">
                          RSA Services{" "}
                          <img src="/icons/down-arrow.svg" alt="vinayak24x7" />
                        </Link>
                        <ul className="DropDownMenu">
                          <li>
                            <Link to="/">Battry Jumpstart</Link>
                          </li>
                          <li>
                            <Link to="/">Flat Tyre</Link>
                          </li>
                          <li>
                            <Link to="/">Instant Car Repair</Link>
                          </li>
                          <li>
                            <Link to="/">Key LockOut</Link>
                          </li>
                          <li>
                            <Link to="/">Mechanical Fault</Link>
                          </li>
                          <li>
                            <Link to="/">Towing Services</Link>
                          </li>
                        </ul>
                      </li>

                      {/* <li>
                        <Link to="/">Contact Us</Link>
                      </li> */}
                    </ul>
                    <button className="menu-bar">
                      <span />
                      <span />
                      <span />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="mobileView">
        <div className="mobileContact"></div>
        <div className="mobileViewDetails">
          <div className="mobileLogo">
            <img src="/logo.png" alt="logo" />
          </div>
          <div className="modal_box" style={{ backgroundColor: "unset" }}>
            <div className="row modal_service">
              <div className="button-container col-sm-12">
                <h2>
                  Prepay &amp; Get Mechanic Dispatched Immediately
                  –&nbsp;No&nbsp;Delays!
                </h2>
                <button
                  className="fill_btn animated-button"
                  fdprocessedid="p1brq"
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>
          <div
            className="font-17 text-black-333 mb-2 font-weight-600"
            style={{ textAlign: "center" }}
          >
            <a href="tel:+916367607678">
              <i className="fa fa-phone-square text-theme-colored font-18" />
              +91-6367607678
            </a>{" "}
            <br />
            <span className="font-14 text-gray">
              Emergency Car Breakdown Service
            </span>
          </div>
          <div className="widget no-border m-0">
            <div className="mt-30 mb-10 text-right flip sm-text-center">
              <div
                className="font-17 text-black-333 mb-4 font-weight-600"
                style={{ textAlign: "center" }}
              >
                <a href="tel:+916367607678">
                  <i className="fa fa-car text-theme-colored font-18" />
                  24/7 Car Mechanic
                  <br />
                  <span className="font-14 text-gray">
                    Mechanic on your Way!!!
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="mt-30 mb-10 text-right flip sm-text-center">
            <div
              className="font-17 text-black-333 mb-4 font-weight-600"
              style={{ textAlign: "center" }}
            >
              <a href="tel:++916367607678">
                <i className="fa fa-clock" aria-hidden="true" />
                Roadside Assistance
                <br />
                <span className="font-14 text-gray">Car Mechanic Near Me</span>
              </a>
            </div>
          </div>
        </div>
        <div className="smMenuTrigger">
          <div className="container">
            <div className="row">
              <div className="col-6">
                <div className="smMenuBar" style={{ textAlign: "left" }}>
                  <i className="fa-solid fa-bars-staggered" />
                </div>
              </div>
              <div className="col-6">
                <div className="smMenuBar" style={{ textAlign: "right" }}>
                  <Link to="/">
                    {" "}
                    <span>Menu</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
